import React from 'react';
import { IconProps } from '../types';
const MinecraftWolfArmor: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="3" y="2" width="1" height="1" fill="rgba(130, 72, 72, 255)" />
<rect x="5" y="2" width="1" height="1" fill="rgba(173, 113, 109, 255)" />
<rect x="6" y="2" width="1" height="1" fill="rgba(160, 100, 96, 255)" />
<rect x="7" y="2" width="1" height="1" fill="rgba(182, 123, 118, 255)" />
<rect x="8" y="2" width="1" height="1" fill="rgba(173, 113, 109, 255)" />
<rect x="9" y="2" width="1" height="1" fill="rgba(182, 123, 118, 255)" />
<rect x="1" y="3" width="1" height="1" fill="rgba(173, 113, 109, 255)" />
<rect x="2" y="3" width="1" height="1" fill="rgba(182, 123, 118, 255)" />
<rect x="3" y="3" width="1" height="1" fill="rgba(173, 113, 109, 255)" />
<rect x="4" y="3" width="1" height="1" fill="rgba(92, 45, 48, 255)" />
<rect x="5" y="3" width="1" height="1" fill="rgba(160, 100, 96, 255)" />
<rect x="6" y="3" width="1" height="1" fill="rgba(150, 89, 84, 255)" />
<rect x="7" y="3" width="1" height="1" fill="rgba(182, 123, 118, 255)" />
<rect x="8" y="3" width="1" height="1" fill="rgba(160, 100, 96, 255)" />
<rect x="9" y="3" width="1" height="1" fill="rgba(182, 123, 118, 255)" />
<rect x="10" y="3" width="1" height="1" fill="rgba(92, 45, 48, 255)" />
<rect x="11" y="3" width="1" height="1" fill="rgba(130, 72, 72, 255)" />
<rect x="12" y="3" width="1" height="1" fill="rgba(182, 123, 118, 255)" />
<rect x="13" y="3" width="1" height="1" fill="rgba(160, 100, 96, 255)" />
<rect x="14" y="3" width="1" height="1" fill="rgba(198, 136, 132, 255)" />
<rect x="1" y="4" width="1" height="1" fill="rgba(160, 100, 96, 255)" />
<rect x="2" y="4" width="1" height="1" fill="rgba(173, 113, 109, 255)" />
<rect x="3" y="4" width="1" height="1" fill="rgba(150, 89, 84, 255)" />
<rect x="4" y="4" width="1" height="1" fill="rgba(92, 45, 48, 255)" />
<rect x="5" y="4" width="1" height="1" fill="rgba(160, 100, 96, 255)" />
<rect x="6" y="4" width="1" height="1" fill="rgba(130, 72, 72, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(182, 123, 118, 255)" />
<rect x="8" y="4" width="1" height="1" fill="rgba(150, 89, 84, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(160, 100, 96, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(92, 45, 48, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(113, 62, 62, 255)" />
<rect x="12" y="4" width="1" height="1" fill="rgba(160, 100, 96, 255)" />
<rect x="13" y="4" width="1" height="1" fill="rgba(150, 89, 84, 255)" />
<rect x="14" y="4" width="1" height="1" fill="rgba(198, 136, 132, 255)" />
<rect x="2" y="5" width="1" height="1" fill="rgba(150, 89, 84, 255)" />
<rect x="3" y="5" width="1" height="1" fill="rgba(130, 72, 72, 255)" />
<rect x="4" y="5" width="1" height="1" fill="rgba(92, 45, 48, 255)" />
<rect x="5" y="5" width="1" height="1" fill="rgba(150, 89, 84, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(92, 45, 48, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(160, 100, 96, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(150, 89, 84, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(160, 100, 96, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(92, 45, 48, 255)" />
<rect x="11" y="5" width="1" height="1" fill="rgba(113, 62, 62, 255)" />
<rect x="12" y="5" width="1" height="1" fill="rgba(160, 100, 96, 255)" />
<rect x="13" y="5" width="1" height="1" fill="rgba(150, 89, 84, 255)" />
<rect x="14" y="5" width="1" height="1" fill="rgba(182, 123, 118, 255)" />
<rect x="3" y="6" width="1" height="1" fill="rgba(121, 94, 71, 255)" />
<rect x="4" y="6" width="1" height="1" fill="rgba(92, 45, 48, 255)" />
<rect x="5" y="6" width="1" height="1" fill="rgba(130, 72, 72, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(92, 45, 48, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(160, 100, 96, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(92, 45, 48, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(160, 100, 96, 255)" />
<rect x="10" y="6" width="1" height="1" fill="rgba(92, 45, 48, 255)" />
<rect x="11" y="6" width="1" height="1" fill="rgba(92, 45, 48, 255)" />
<rect x="12" y="6" width="1" height="1" fill="rgba(113, 62, 62, 255)" />
<rect x="13" y="6" width="1" height="1" fill="rgba(92, 45, 48, 255)" />
<rect x="14" y="6" width="1" height="1" fill="rgba(113, 62, 62, 255)" />
<rect x="3" y="7" width="1" height="1" fill="rgba(153, 123, 96, 255)" />
<rect x="5" y="7" width="1" height="1" fill="rgba(92, 45, 48, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(92, 45, 48, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(92, 45, 48, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(92, 45, 48, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(92, 45, 48, 255)" />
<rect x="12" y="7" width="1" height="1" fill="rgba(121, 94, 71, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(121, 94, 71, 255)" />
<rect x="12" y="8" width="1" height="1" fill="rgba(153, 123, 96, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(150, 89, 84, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(121, 94, 71, 255)" />
<rect x="12" y="10" width="1" height="1" fill="rgba(150, 89, 84, 255)" />
<rect x="13" y="10" width="1" height="1" fill="rgba(121, 94, 71, 255)" />
<rect x="4" y="11" width="1" height="1" fill="rgba(130, 72, 72, 255)" />
<rect x="12" y="11" width="1" height="1" fill="rgba(130, 72, 72, 255)" />
</svg>);
export default MinecraftWolfArmor;